import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationClubMember: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = false, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3884_11333"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3884_11333)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
        <rect
          width="247"
          height="151.381"
          x="54"
          y="50.809"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="2"
        ></rect>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M205.124 158.219c-14.838 15.175 13.565 43.546 27.116 12.536 3.235 18.474 20.666 19.793 25.824 2.639 4.548 12.476 10.19 13.844 21.951 13.196"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M53.839 91.56h246.403"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M88.515 81.164V62.73h-4.888L78.22 76.042 72.681 62.73H67.95v18.434h3.432V68.346l5.304 12.818h2.99l5.304-12.922v12.922h3.536zm6.403-7.852c.078-1.17 1.066-2.522 2.86-2.522 1.976 0 2.808 1.248 2.86 2.522h-5.72zm6.058 3.328c-.416 1.144-1.3 1.95-2.912 1.95-1.716 0-3.146-1.222-3.224-2.912h9.152c0-.052.052-.572.052-1.066 0-4.108-2.366-6.63-6.318-6.63-3.276 0-6.292 2.652-6.292 6.734 0 4.316 3.094 6.838 6.604 6.838 3.146 0 5.174-1.846 5.824-4.056l-2.886-.858zm9.321 4.524v-7.488c0-1.404.884-2.522 2.392-2.522 1.56 0 2.262 1.04 2.262 2.418v7.592h3.432v-7.488c0-1.378.884-2.522 2.366-2.522 1.586 0 2.262 1.04 2.262 2.418v7.592h3.354V72.87c0-3.432-2.262-4.862-4.628-4.862-1.69 0-3.042.572-4.056 2.132-.65-1.378-2.054-2.132-3.796-2.132-1.404 0-3.042.676-3.744 1.924v-1.56h-3.302v12.792h3.458zm22.823 0v-1.56c.676 1.092 2.028 1.872 3.796 1.872 3.64 0 6.032-2.886 6.032-6.76 0-3.796-2.158-6.682-5.902-6.682-1.898 0-3.302.832-3.874 1.742V62.34h-3.406v18.824h3.354zm6.37-6.422c0 2.34-1.404 3.64-3.172 3.64-1.742 0-3.198-1.326-3.198-3.64 0-2.34 1.456-3.614 3.198-3.614 1.768 0 3.172 1.274 3.172 3.614zm8.977-1.43c.078-1.17 1.066-2.522 2.86-2.522 1.976 0 2.808 1.248 2.86 2.522h-5.72zm6.058 3.328c-.416 1.144-1.3 1.95-2.912 1.95-1.716 0-3.146-1.222-3.224-2.912h9.152c0-.052.052-.572.052-1.066 0-4.108-2.366-6.63-6.318-6.63-3.276 0-6.292 2.652-6.292 6.734 0 4.316 3.094 6.838 6.604 6.838 3.146 0 5.174-1.846 5.824-4.056l-2.886-.858zm13.662-8.32c-.26-.026-.52-.052-.806-.052-1.092 0-2.86.312-3.64 2.002v-1.898h-3.354v12.792h3.458v-5.85c0-2.756 1.534-3.614 3.302-3.614.312 0 .65.026 1.04.104V68.32zm1.422 9.282c.156 1.456 1.482 3.952 5.33 3.952 3.354 0 4.966-2.132 4.966-4.212 0-1.872-1.274-3.406-3.796-3.926l-1.82-.39c-.702-.13-1.17-.52-1.17-1.144 0-.728.728-1.274 1.638-1.274 1.456 0 2.002.962 2.106 1.716l2.886-.65c-.156-1.378-1.378-3.692-5.018-3.692-2.756 0-4.784 1.898-4.784 4.186 0 1.794 1.118 3.276 3.588 3.822l1.69.39c.988.208 1.378.676 1.378 1.248 0 .676-.546 1.274-1.69 1.274-1.508 0-2.262-.936-2.34-1.95l-2.964.65zm16.555-3.952c.078-1.404.936-2.496 2.392-2.496 1.664 0 2.366 1.118 2.366 2.548v7.462h3.458v-8.06c0-2.808-1.508-5.07-4.758-5.07-1.222 0-2.626.416-3.458 1.404V62.34h-3.458v18.824h3.458V73.65zm15.082 7.514V68.372h-3.458v12.792h3.458zm-3.874-16.978c0 1.144.962 2.106 2.132 2.106a2.12 2.12 0 002.132-2.106c0-1.196-.936-2.158-2.132-2.158-1.17 0-2.132.962-2.132 2.158zm10.856 21.918v-6.188c.624.858 1.924 1.56 3.692 1.56 3.614 0 6.032-2.86 6.032-6.734 0-3.796-2.158-6.656-5.902-6.656-1.924 0-3.354.858-3.926 1.846v-1.56h-3.354v17.732h3.458zm6.318-11.336c0 2.288-1.404 3.614-3.172 3.614-1.768 0-3.198-1.352-3.198-3.614 0-2.262 1.43-3.588 3.198-3.588s3.172 1.326 3.172 3.588z"
        ></path>
        <rect
          width="55.762"
          height="76.908"
          x="75.147"
          y="107.812"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="2"
        ></rect>
        <mask
          id="mask1_3884_11333"
          style={{ maskType: 'alpha' }}
          width="60"
          height="82"
          x="73"
          y="105"
          maskUnits="userSpaceOnUse"
        >
          <rect
            width="55.762"
            height="76.908"
            x="75.144"
            y="107.812"
            fill={colors.primary[100]}
            stroke={colors.primary[500]}
            strokeWidth="4"
            rx="2"
          ></rect>
        </mask>
        <g
          stroke={colors.primary[500]}
          strokeWidth="4"
          mask="url(#mask1_3884_11333)"
        >
          <circle cx="102.566" cy="183.042" r="27.421" fill="#fff"></circle>
          <rect
            width="25.421"
            height="31.857"
            x="89.855"
            y="115.328"
            fill="#fff"
            rx="12.711"
          ></rect>
          <rect
            width="55.762"
            height="76.908"
            x="75.144"
            y="107.812"
            rx="2"
          ></rect>
        </g>
        <rect
          width="26.341"
          height="10.711"
          x="151.455"
          y="107.812"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="5.355"
        ></rect>
        <rect
          width="26.341"
          height="10.711"
          x="187.312"
          y="107.812"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="5.355"
        ></rect>
        <rect
          width="26.341"
          height="10.711"
          x="241.557"
          y="107.812"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="5.355"
        ></rect>
        <rect
          width="26.341"
          height="10.711"
          x="151.455"
          y="128.959"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="5.355"
        ></rect>
        <rect
          width="35.535"
          height="10.711"
          x="187.312"
          y="128.959"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="5.355"
        ></rect>
        <rect
          width="23.582"
          height="10.711"
          x="232.363"
          y="128.959"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="5.355"
        ></rect>
      </g>
    </svg>
  );
};

export default IllustrationClubMember;
